export type ApiValidationErrorResponse = ApiValidationErrorDetail[];

export type ApiValidationErrorDetail = {
  type: string;
  loc: (string | number)[];
  msg: string;
  input?: unknown;
  ctx?: Record<string, unknown>;
};

export function gatherValidationMessages(
  err: ApiValidationErrorResponse,
  separator: string = ' '
): string {
  return err.map((d) => d.msg).join(separator);
}
